import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_COUNT } from './url-constants';

type SiteDevicesCountEndpointSpecification = ApiEndpointSpecification;
export const SiteDevicesCountEndpointSpecification: SiteDevicesCountEndpointSpecification = {
    url: DEVICE_COUNT,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteDevicesCountRequestParams',
    requestBodySchemaName: 'SiteDevicesCountRequestBody',
    okResponseSchemaName: 'SiteDevicesCountOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteDevicesCount = Helpers.makeApiRequestFn<
    Types.SiteDevicesCountRequestParams,
    Types.SiteDevicesCountRequestBody,
    Types.SiteDevicesCountOkResponse
>(SiteDevicesCountEndpointSpecification);
